import React from "react"
import styles from "../../styles/dropcap.module.scss"

const Dropcap = ({ img, children }) => {
    return (
        <span className={styles.main}>
            <img src={img} alt={children} />
            <span>{children}</span>
        </span>
    )
}

export default Dropcap
